var map = {
	"./100-logo-black.svg": 92,
	"./Braun-logo-black.svg": 90,
	"./Braun-logo-white.svg": 91,
	"./btn-next_dark.svg": 69,
	"./room-back-black.svg": 146,
	"./room-back-white.svg": 147,
	"./timeline-back-black.svg": 148,
	"./timeline-back-white.svg": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 145;